import { render, staticRenderFns } from "./ReportHeadmenuLayout.vue?vue&type=template&id=af72dbfc&scoped=true&lang=pug&"
import script from "./ReportHeadmenuLayout.vue?vue&type=script&lang=ts&"
export * from "./ReportHeadmenuLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ReportHeadmenuLayout.vue?vue&type=style&index=0&id=af72dbfc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af72dbfc",
  null
  
)

export default component.exports